// extracted by mini-css-extract-plugin
module.exports = {"warning":"DuplicateIdsWarning_warning__sJ8iG","lenkeInline":"DuplicateIdsWarning_lenkeInline__hn3_F"};